import type { FacilityId, PrefectureId, Program } from '@gyym/sdk'

import { buildFacilityLink } from '@/modules/Facilities'

export const buildProgramLink = (
  facility: {
    id: FacilityId
    cityCode: number
    prefectureId: PrefectureId
  },
  program: { id: Program['id'] },
) => {
  const { href: facilityHref, as: facilityAs } = buildFacilityLink(facility)

  const href = {
    pathname: `${facilityHref.pathname}/programs/[programId]`,
    query: {
      ...facilityHref.query,
      programId: program.id,
    },
  }

  const as = `${facilityAs}/programs/${program.id}`

  return { href, as }
}
